(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    window.onload = function () {
    window.fitmixInstance = FitMix.createWidget('fitmix-container', window.fittingboxParams);
  };

  window.addEventListener('load', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('show_vto') === 'true') {
      setTimeout(function () {
        const vtoLink = document.querySelector('.vto__link');
        if (vtoLink) vtoLink.click();
        window.history.replaceState(null, '', window.location.pathname);
      }, 500);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-read-more-btn]').forEach((btn) => {
      const block = btn.previousElementSibling;
      block.dataset.collapsed = '';

      btn.addEventListener('click', () => {
        const isCollapsed = 'collapsed' in block.dataset;
        if (isCollapsed) {
          delete block.dataset.collapsed;
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('[data-read-more-label]').hidden = true;
          btn.querySelector('[data-read-less-label]').hidden = false;
        } else {
          block.dataset.collapsed = '';
          btn.setAttribute('aria-expanded', 'false');
          btn.querySelector('[data-read-more-label]').hidden = false;
          btn.querySelector('[data-read-less-label]').hidden = true;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
